export const translations = {
  en: {
    "nav.features": "Features",
    "nav.testimonials": "Testimonials",
    "nav.pricing": "Pricing",
    "nav.faq": "FAQ",
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "hero.title": "Track Your English Learning Journey Like Never Before",
    "hero.description": "Learn English in a simplified and direct way using Arabic. Our platform makes learning English accessible and effective for Arabic speakers.",
    "hero.download": "Download Now",
    "hero.learnMore": "Learn More",
    "hero.trusted": "Trusted by language learners worldwide",
    "hero.whyTitle": "Why Arabic With English?",
    "hero.vocabulary.title": "Vocabulary Building",
    "hero.vocabulary.description": "Learn essential words and expressions",
    "hero.grammar.title": "Grammar Rules",
    "hero.grammar.description": "Understand language structure and rules",
    "hero.conversation.title": "Conversation Skills",
    "hero.conversation.description": "Practice speaking in real-life situations",
    "hero.mastery.title": "Language Mastery",
    "hero.mastery.description": "Achieve fluency in English with confidence",
    "hero.videoLessons.title": "Video Lessons",
    "hero.videoLessons.description": "Learn through short videos explained in clear Arabic",
    "hero.nativeTeachers.title": "Native Teachers",
    "hero.nativeTeachers.description": "Professional teachers whose native language is English!",
    "hero.curriculum.title": "Structured Curriculum",
    "hero.curriculum.description": "From basics to proficiency, step by step",
    "hero.certificates.title": "Achievement Certificates",
    "hero.certificates.description": "Get a certified certificate upon completion of each level",
    "hero.community.title": "Supportive Community",
    "hero.community.description": "Interact with students like you and practice with them on the platform",
    "hero.progress.title": "Track Progress",
    "hero.progress.description": "Smart dashboard showing your level and how much is left to reach your goal!",
    "features.title": "Everything You Need to Succeed",
    "features.subtitle": "Our comprehensive suite of features helps you stay on track, motivated, and achieving your fitness goals.",
    "testimonials.title": "Trusted by Thousands of Fitness Enthusiasts",
    "testimonials.subtitle": "See how FitTrack has helped people transform their lives and achieve their fitness goals.",
    "testimonials.seeAll": "See all reviews",
    "features.smartWorkout.title": "Smart Workout Tracking",
    "features.smartWorkout.description": "Automatically track your exercises, sets, and reps with intelligent recognition technology.",
    "features.health.title": "Health Monitoring",
    "features.health.description": "Track vital health metrics including heart rate, sleep quality, and recovery status.",
    "features.nutrition.title": "Nutrition Logging",
    "features.nutrition.description": "Log meals easily with our extensive food database and get personalized nutrition insights.",
    "features.ai.title": "AI-Powered Plans",
    "features.ai.description": "Get customized workout and nutrition plans that adapt to your progress and goals.",
    "features.community.title": "Community Support",
    "features.community.description": "Connect with like-minded fitness enthusiasts and share your journey with others.",
    "features.analytics.title": "Progress Analytics",
    "features.analytics.description": "Visualize your fitness journey with detailed charts and progress tracking.",
    "stats.activeUsers": "10k+ Active Users",
    "stats.rating": "4.8/5 Rating",
    "stats.workouts": "1M+ Workouts Tracked",
    "pricing.title": "Simple, Transparent Pricing",
    "pricing.subtitle": "Choose the plan that best fits your fitness journey",
    "pricing.monthly": "Monthly",
    "pricing.annual": "Annual",
    "pricing.save": "Save 17%",
    "pricing.popular": "Most Popular",
    "pricing.perMonth": "/month",
    "pricing.perYear": "/year",
    "pricing.free.name": "Basic",
    "pricing.free.description": "Perfect for getting started",
    "pricing.free.button": "Start Free",
    "pricing.free.features.tracking": "Basic workout tracking",
    "pricing.free.features.basic": "Basic analytics",
    "pricing.free.features.community": "Community access",
    "pricing.pro.name": "Pro",
    "pricing.pro.description": "For serious fitness enthusiasts",
    "pricing.pro.button": "Get Pro",
    "pricing.pro.features.all": "Everything in Basic",
    "pricing.pro.features.advanced": "Advanced workout tracking",
    "pricing.pro.features.nutrition": "Nutrition planning",
    "pricing.pro.features.coaching": "AI coaching",
    "pricing.pro.features.analytics": "Advanced analytics",
    "pricing.enterprise.name": "Elite",
    "pricing.enterprise.description": "For professional athletes",
    "pricing.enterprise.button": "Contact Sales",
    "pricing.enterprise.features.all": "Everything in Pro",
    "pricing.enterprise.features.custom": "Custom workout plans",
    "pricing.enterprise.features.priority": "Priority support",
    "pricing.enterprise.features.api": "API access",
    "pricing.enterprise.features.dedicated": "Dedicated account manager",
    "testimonials.page.title": "Success Stories",
    "testimonials.page.subtitle": "Discover how FitTrack has helped thousands of people achieve their fitness goals and transform their lives.",
    "testimonials.page.featuredVideos": "Featured Video Testimonials",
    "testimonials.stats.totalReviews": "Total Reviews",
    "testimonials.stats.averageRating": "Average Rating",
    "testimonials.stats.successRate": "Success Rate",
    "testimonials.stats.videoTestimonials": "Video Stories",
    "testimonials.search.placeholder": "Search testimonials...",
    "testimonials.filters.label": "Filters",
    "testimonials.categories.all": "All Categories",
    "testimonials.categories.weightLoss": "Weight Loss",
    "testimonials.categories.muscleGain": "Muscle Gain",
    "testimonials.categories.running": "Running",
    "testimonials.categories.yoga": "Yoga",
    "testimonials.sort.recent": "Most Recent",
    "testimonials.sort.rating": "Highest Rated",
    "testimonials.sort.helpful": "Most Helpful",
    "waitlist.comingSoon": "Coming Soon",
    "waitlist.title": "Join the Waitlist for Early Access",
    "waitlist.description": "Be among the first to experience the future of language learning. Sign up now and get exclusive early access benefits.",
    "waitlist.emailPlaceholder": "Enter your email address",
    "waitlist.joinButton": "Join Waitlist",
    "waitlist.success": "You're on the list! We'll notify you when we launch.",
    "waitlist.stats.inQueue": "People in Queue",
    "waitlist.stats.untilLaunch": "Until Launch",
    "waitlist.stats.earlyDiscount": "Early Bird Discount",
    "waitlist.benefitsTitle": "Early Access Benefits",
    "waitlist.benefits.early": "First access to all features",
    "waitlist.benefits.discount": "50% discount on annual plans",
    "waitlist.benefits.features": "Beta access to new features",
    "waitlist.benefits.support": "Priority customer support"
  },
  ar: {
    "nav.features": "المميزات",
    "nav.testimonials": "آراء المستخدمين",
    "nav.pricing": "الأسعار",
    "nav.faq": "الأسئلة الشائعة",
    "nav.login": "تسجيل الدخول",
    "nav.signup": "إنشاء حساب",
    "hero.title": "تعلم اللغة الإنجليزية بطريقة جديدة كلياً",
    "hero.description": "منصة تعليمية تشرح اللغة الإنجليزية بطريقة مبسطة ومباشرة باستخدام اللغة العربية، مما يجعل تعلم الإنجليزية في متناول الجميع.",
    "hero.download": "تحميل التطبيق",
    "hero.learnMore": "اعرف المزيد",
    "hero.trusted": "موثوق به من قبل متعلمي اللغة في جميع أنحاء العالم",
    "hero.whyTitle": "لماذا Arabic With English?",
    "hero.vocabulary.title": "بناء المفردات",
    "hero.vocabulary.description": "تعلم الكلمات والتعبيرات الأساسية",
    "hero.grammar.title": "قواعد اللغة",
    "hero.grammar.description": "فهم بنية وقواعد اللغة بشكل صحيح",
    "hero.conversation.title": "مهارات المحادثة",
    "hero.conversation.description": "تدرب على التحدث في مواقف الحياة الواقعية",
    "hero.mastery.title": "إتقان اللغة",
    "hero.mastery.description": "تحقيق الطلاقة في اللغة الإنجليزية بثقة",
    "hero.videoLessons.title": "دروس فيديو",
    "hero.videoLessons.description": "تعلم من خلال مقاطع فيديو قصيرة مشروحة باللغة العربية الواضحة",
    "hero.nativeTeachers.title": "معلمون ناطقون باللغة",
    "hero.nativeTeachers.description": "معلمون محترفون لغتهم الأم هي الإنجليزية!",
    "hero.curriculum.title": "منهج منظم",
    "hero.curriculum.description": "من الأساسيات إلى الاحتراف، خطوة بخطوة",
    "hero.certificates.title": "شهادات الإنجاز",
    "hero.certificates.description": "احصل على شهادة معتمدة عند إكمال كل مستوى",
    "hero.community.title": "مجتمع داعم",
    "hero.community.description": "تفاعل مع طلاب مثلك وتدرب معهم على المنصة",
    "hero.progress.title": "تتبع التقدم",
    "hero.progress.description": "لوحة تحكم ذكية تظهر مستواك وكم تبقى للوصول إلى هدفك!",
    "features.title": "كل ما تحتاجه للنجاح",
    "features.subtitle": "مجموعة شاملة من الميزات لمساعدتك على تعلم اللغة الإنجليزية بفعالية",
    "waitlist.comingSoon": "قريباً",
    "waitlist.title": "انضم إلى قائمة الانتظار للوصول المبكر",
    "waitlist.description": "كن من أوائل من يختبرون مستقبل تعلم اللغات. سجل الآن واحصل على مزايا الوصول المبكر الحصرية.",
    "waitlist.emailPlaceholder": "أدخل بريدك الإلكتروني",
    "waitlist.joinButton": "انضم إلى قائمة الانتظار",
    "waitlist.success": "أنت الآن على القائمة! سنخبرك عند الإطلاق.",
    "waitlist.stats.inQueue": "شخص في قائمة الانتظار",
    "waitlist.stats.untilLaunch": "حتى الإطلاق",
    "waitlist.stats.earlyDiscount": "خصم للمسجلين مبكراً",
    "waitlist.benefitsTitle": "مزايا الوصول المبكر",
    "waitlist.benefits.early": "الوصول الأول لجميع الميزات",
    "waitlist.benefits.discount": "خصم 50% على الاشتراكات السنوية",
    "waitlist.benefits.features": "وصول تجريبي للميزات الجديدة",
    "waitlist.benefits.support": "دعم عملاء ذو أولوية",
    "settings.language": "اللغة",
    "settings.theme": "المظهر",
    "settings.light": "فاتح",
    "settings.dark": "داكن"
  }
}